<ng-container *ngIf="permConfig.isViewAllowed">
    <div class="container-fluid">
        <app-page-title title="List Job Queue"></app-page-title>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div
                        class="card-header bg-transparent border-bottom text-uppercase d-flex justify-content-between align-items-center">
                        <span></span>
                        <button type="button" class="btn btn-primary btn-sm d-flex align-items-center"
                            (click)="refreshGrid()">
                            <i class='mdi mdi-sync'></i>Refresh
                        </button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12 grid-container">
                                <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                    class="ag-theme-balham" [rowData]="rowDataJobQueue"
                                    [columnDefs]="columnDefsJobQueue" [animateRows]="true" [context]="context"
                                    [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" (cellClicked)="onCellClicked($event)"
                                    [suppressMenuHide]="true" [enableCellTextSelection]="true" [pagination]="true"
                                    (gridReady)="onGridReady($event)">
                                </ag-grid-angular>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>